import { render, staticRenderFns } from "./setType.vue?vue&type=template&id=80e9466c&"
import script from "./setType.vue?vue&type=script&lang=js&"
export * from "./setType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports